import { useEffect, useState, type JSX } from 'react';

import { fetchEvent } from 'app-migration/api/api';
import KalshiLogo from 'components/DesignSystem/Icons/adhoc/KalshiLogo';
import Palette from 'DesignSystem2/Theme/Palette';
import Body from 'DesignSystem3/Text/Body';
import type { MarketVo } from 'models';
import { marketLastPriceCents, marketLastPriceChangeCents, complementCents } from 'models/market';

import HeroCard from './HeroCard';

interface MediumVariantCDProps {
    isVariantC: boolean;
    market: MarketVo;
    eventName: string;
    eventTicker: string;
    goToMarket: () => void;
    darkMode: boolean;
}

const MediumVariantCD = ({
    isVariantC,
    market,
    eventTicker,
    goToMarket,
    darkMode,
}: MediumVariantCDProps): JSX.Element => {
    const [odds, setOdds] = useState(marketLastPriceCents(market));
    const [change, setChange] = useState(marketLastPriceChangeCents(market));

    useEffect(() => {
        const interval = setInterval(() => {
            fetchEvent(eventTicker).then((event) => {
                if (event) {
                    const updated_market = event.markets.find((m) => m.ticker_name === market.ticker_name);
                    if (updated_market) {
                        setOdds(marketLastPriceCents(updated_market));

                        const rawChange = marketLastPriceChangeCents(updated_market);
                        setChange(rawChange);
                    }
                }
            });
        }, 30000);

        return () => clearInterval(interval);
    }, [market.ticker_name, eventTicker]);

    return (
        <div className="flex flex-col w-full gap-1 cursor-pointer align-start" onClick={goToMarket}>
            <div
                className={
                    'flex justify-center items-end self-stretch ' +
                    (isVariantC
                        ? 'border border-1 border-fill-x40 border-solid rounded-x30 px-2 gap-3 bg-surface-x10'
                        : 'gap-1')
                }
            >
                <HeroCard
                    isTrump={true}
                    isCVariant={isVariantC}
                    odds={complementCents(odds)}
                    change={-change}
                    left={true}
                    darkMode={darkMode}
                />
                <HeroCard
                    isTrump={false}
                    isCVariant={isVariantC}
                    odds={odds}
                    change={change}
                    left={false}
                    darkMode={darkMode}
                />
            </div>
            <div className="flex items-center self-stretch justify-between px-1 pb-1 text-text-x20">
                <Body.x10>Live bets: Kalshi.com</Body.x10>
                <KalshiLogo color={Palette.Brand.Primary} height="12px" />
            </div>
        </div>
    );
};

export default MediumVariantCD;
